module.exports = __webpack_public_path__ + "img/northumberland-logo-web.61ae137e.jpg";